import { Injectable } from '@angular/core';

import { WallObjectDrag } from './wall-object-drag';
import { ObjectCheckerService } from '../../../../../services/object-checker.service';
import { CollisionService } from '../../../../../services/collision/collision.service';
import { DragHandlerBase } from '../../Handler/drag-handler-base';

// Plane drag for standalone wall-mounted products (wallInteraction: 'mountable',
// e.g. Trellis). Awnings keep their own group-aware AwningDrag.
class WallMountedObjectDrag extends WallObjectDrag {
  canExecute(selected) {
    return selected.every(
      obj =>
        this.objectCheckerSrvc.isWallMountable(obj) && !this.objectCheckerSrvc.isAwning(obj)
    );
  }

  getStaticObjectsFilter(objects) {
    const baseFilter = super.getStaticObjectsFilter(objects);
    return obj => baseFilter(obj) && this.objectCheckerSrvc.isWallMountable(obj);
  }
}

@Injectable()
export class WallMountedObjectDragFactory {
  constructor(
    private objectCheckerSrvc: ObjectCheckerService,
    private collisionSrvc: CollisionService
  ) {}

  create(nextHandler?: DragHandlerBase) {
    return new WallMountedObjectDrag(nextHandler, this.objectCheckerSrvc, this.collisionSrvc);
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/WallObject/wall-mounted-object-drag.ts